import { render, staticRenderFns } from "./canevastitle.vue?vue&type=template&id=11bac946&scoped=true&"
var script = {}
import style0 from "./canevastitle.vue?vue&type=style&index=0&id=11bac946&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bac946",
  null
  
)

export default component.exports